export enum AnalyticEvents {
  SelectItem = 'select_item',
  ViewItem = 'view_item',
  ViewItemList = 'view_item_list',
  BeginCheckout = 'begin_checkout',
  AddToCart = 'add_to_cart',
  Purchase = 'purchase',
  ViewPromotion = 'view_promotion',
  SelectPromotion = 'select_promotion',
  ViewCart = 'view_cart',
  RemoveFromCart = 'remove_from_cart',
  AddToWishlist = 'add_to_wishlist',
  RemoveFromWishlist = 'remove_from_wishlist',
  ApplyCoupon = 'apply_coupon',
  AddPaymentInfo = 'add_payment_info',
  LocationSuggestion = 'location_suggestion',
  Search = 'search',
  AddShippingInfo = 'add_shipping_info',
  ViewRetailerList = 'view_retailer_list',
  SelectRetailer = 'select_retailer',
  ViewRetailer = 'view_retailer',
  SelectAffiliateLink = 'select_affiliate_link',
  CartPopupRemoveFromCart = 'cart_popup_remove_from_cart',
}
